module.exports = __webpack_public_path__ + "img/mind_extremely_drawoblique_bg.ffefad91.png";